  
import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import apiClient from "./plugins/axios";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'; 
import VueGoogleMaps from "@fawmi/vue-google-maps";
import { createHead } from '@vueuse/head';


const app = createApp(App);
const head = createHead();

app.config.globalProperties.$axios = apiClient;
app.config.globalProperties.$server = "https://mh13.in/app/";
app.config.globalProperties.$hostname = 'https://mh13.in/app/'
app.config.globalProperties.$asset_path = 'https://mh13.in/app/public/uploads/'
app.provide('$axios', apiClient); // Provide Axios globally
 
app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyD9gtJ2oDY7AcqUPTjmER1Ki0ZYC4mbIe0", // Replace with your actual API key
    libraries: "places",
  },
});
app.use(store);
app.use(VueSweetalert2);
app.use(head);
app.use(router).mount('#app');